// Centralised data-testid registry
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const AUTH = {
  loginForm: "login-form",
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitBtn: "login-submit-btn",
  logoutBtn: "logout-btn",
  errorAlert: "login-error-alert",
  demoAdmin: "demo-fill-admin",
  demoCompanyAdmin: "demo-fill-companyadmin",
  demoHr: "demo-fill-hr",
  demoManager: "demo-fill-manager",
  demoEmployee: "demo-fill-employee",
};

export const SHELL = {
  sidebar: "app-sidebar",
  topbar: "app-topbar",
  tenantSwitcher: "tenant-switcher",
  notifBell: "notif-bell",
  userMenu: "user-menu",
  navDashboard: "nav-dashboard",
  navEmployees: "nav-employees",
  navAttendance: "nav-attendance",
  navLeaves: "nav-leaves",
  navHolidays: "nav-holidays",
  navCheckin: "nav-checkin",
  navProfile: "nav-profile",
  navTenants: "nav-tenants",
};

export const DASH = {
  root: "dashboard-root",
  statEmployees: "stat-employees",
  statPresent: "stat-present",
  statOnLeave: "stat-on-leave",
  statPending: "stat-pending",
};

export const EMP = {
  list: "employees-list",
  createBtn: "employees-create-btn",
  searchInput: "employees-search-input",
  createDialog: "employee-create-dialog",
  saveBtn: "employee-save-btn",
  row: (id) => `employee-row-${id}`,
  detailRoot: "employee-detail-root",
};

export const ATT = {
  checkInBtn: "attendance-check-in-btn",
  checkOutBtn: "attendance-check-out-btn",
  monthTable: "attendance-month-table",
  adminTable: "attendance-admin-table",
};

export const LEAVE = {
  applyBtn: "leave-apply-btn",
  applyDialog: "leave-apply-dialog",
  submitBtn: "leave-submit-btn",
  typeSelect: "leave-type-select",
  startInput: "leave-start-input",
  endInput: "leave-end-input",
  reasonInput: "leave-reason-input",
  approveBtn: (id) => `leave-approve-${id}`,
  rejectBtn: (id) => `leave-reject-${id}`,
  myList: "my-leaves-list",
  adminList: "admin-leaves-list",
};

export const TENANT = {
  createBtn: "tenant-create-btn",
  createDialog: "tenant-create-dialog",
  list: "tenants-list",
};
